import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { accessBannerContent } from './accessBanner';

const TONES = {
  red: 'border-red-200 bg-red-50 text-red-800',
  amber: 'border-amber-200 bg-amber-50 text-amber-900',
  blue: 'border-blue-200 bg-blue-50 text-blue-900',
};

/** Trial/comp ended, or the organization is read-only. Renders nothing otherwise. */
export default function AccessBanner({ access, readOnly, canManageBilling }) {
  const content = accessBannerContent({ access, readOnly, canManageBilling });
  if (!content) return null;
  return (
    <div
      role="status"
      className={clsx('mb-4 flex flex-wrap items-center gap-3 rounded-lg border px-4 py-2.5 text-sm', TONES[content.tone])}
    >
      <span className="flex-1">{content.text}</span>
      {content.action && (
        <Link to={content.action.to} className="font-semibold underline-offset-2 hover:underline">
          {content.action.label}
        </Link>
      )}
    </div>
  );
}
